const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMERIC_SEGMENT = /^\d+$/

const ROUTE_PARAM_PLACEHOLDER = ':id'

export const normalizeRoute = (pathname: string): string => {
  if (pathname === '') {
    return pathname
  }

  const normalized = pathname
    .split('/')
    .map((segment) =>
      UUID_SEGMENT.test(segment) || NUMERIC_SEGMENT.test(segment)
        ? ROUTE_PARAM_PLACEHOLDER
        : segment,
    )
    .join('/')

  return normalized.length > 1 && normalized.endsWith('/') ? normalized.slice(0, -1) : normalized
}
